import { links } from '../links';
export default function panic(errorGuid: string){
    window.location.assign(links.errorHref + "?e=" + errorGuid);
}
